import SEOLandingTemplate from './SEOLandingTemplate';

export default function KeywordResearchPage() {
  return (
    <SEOLandingTemplate
      title="Keyword Research Tool"
      metaTitle="Free Keyword Research Tool | Sungresh"
      metaDescription="Research keywords with real search volume, difficulty score, CPC, and search intent data from DataForSEO. Free credits on signup."
      h1="Free Keyword Research Tool"
      sub="Search volume, difficulty, CPC, and intent for any seed keyword, plus SERP-level detail on who's currently ranking — all from DataForSEO's data."
      keywords="keyword research tool, free keyword research tool, keyword research"
      ctaLink="/keywords/magic"
      ctaText="Find Keywords Free"
      features={[
        { icon: '🔍', title: 'Search Volume', desc: 'Monthly search volume per keyword' },
        { icon: '⚡', title: 'Difficulty Score', desc: 'A 0-100 estimate of ranking difficulty' },
        { icon: '💰', title: 'CPC & Competition', desc: 'Advertiser competition and cost data' },
        { icon: '🎯', title: 'Search Intent', desc: 'Informational, commercial, transactional, or navigational' },
        { icon: '❓', title: 'Question Keywords', desc: 'Question-phrased variations for FAQ and AI-search content' },
        { icon: '📊', title: 'SERP Detail', desc: 'A look at who currently ranks for each keyword' },
      ]}
      faqs={[
        { q: 'How do I do keyword research with this tool?', a: 'Start with a broad seed keyword in the Keyword Magic Tool, review the ideas it returns, filter by difficulty and volume to find realistic targets, and check the Questions tab for content-angle ideas.' },
        { q: 'Where does the keyword data come from?', a: 'DataForSEO, a third-party keyword and SERP data provider used by many SEO tools. When API credentials aren\'t configured, the tool clearly labels any fallback sample data as such.' },
        { q: 'How do I find keywords with realistic competition for a newer site?', a: 'Filter for lower difficulty scores while keeping an eye on search volume — you\'re looking for the overlap between "achievable" and "worth ranking for."' },
      ]}
    />
  );
}
